import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Frequency = Loadable(lazy(() => import('./frequency')));

const frequencyRoutes = [
  { path: '/dashboard/frequency', element: <Frequency />, auth: authRoles.admin },
];

export default frequencyRoutes;
